export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-trash-bbf02d8031daedf6fda1b5a8f102a9c5.svg";